document.addEventListener('DOMContentLoaded', function() {
  initResourcesBlock();
  
  // Check if we need to scroll to resources section
  if (sessionStorage.getItem('scrollToResources')) {
    scrollToResourcesSection();
    // Clear the flag after scrolling
    sessionStorage.removeItem('scrollToResources');
  }
});

function initResourcesBlock() {
  const categoryLinks = document.querySelectorAll('.resources__list-item-link');
  
  categoryLinks.forEach(function(link) {
    link.addEventListener('click', function(e) {
      // Store a flag in sessionStorage to indicate we should scroll after page reload
      sessionStorage.setItem('scrollToResources', 'true');
    });
  });
}

function scrollToResourcesSection() {
  const resourcesSection = document.querySelector('.resources');
  
  if (resourcesSection) {
    // Instantly bring the section into view without animation
    resourcesSection.scrollIntoView({ behavior: 'auto', block: 'start' });
  }
}